import React from "react";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer>
      <div className="footer">
        <span>
          <a
            href="https://www.providusbank.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            ProvidusBank {year}
          </a>
        </span>
      </div>
    </footer>
  );
};

export default Footer;
